// extracted by mini-css-extract-plugin
module.exports = {"noAccessErrorText":"_24WXukF1","noAccessContent":"_1Y216Y33"};